import PrescriptionCard from "./PrescriptionCard";

export default PrescriptionCard;
